import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "umi";
import Abnormal from "@home/components/Abnormal";
import { Progress } from "tea-component";
import { getLanguage } from "@home/utils/common";
import { LANGUAGE_EN } from "@home/_config/config";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import './index.scss';
import moment from "moment";
import CommonBubble from "@home/components/CommonBubble";
import RevenueProgressTooltip from "./Tooltip";

const RevenueProgress = (props: any) => {
  const {
    data,
    changeData,
    period: propsPeriod,
    percentFormatRule = "int",
    preUnit = "$",
    endUnit = "",
    tabFilter,
    options = [
      {
        key: "quarter1",
        text: "Q1",
        color: "#172F80",
      },
      {
        key: "quarter2",
        text: "Q2",
        color: "#3965CC",
      },
      {
        key: "quarter3",
        text: "Q3",
        color: "#7CADFC",
      },
      {
        key: "quarter4",
        text: "Q4",
        color: "#D0E4FE",
      },
    ],
    metricsMap = {
      profit: {
        nameEn: "Revenue Completion %",
        nameCn: "总收入完成度",
      },
      units_number: {
        nameEn: "Total Sales Units Completion %",
        nameCn: "总本体拷贝净销量完成度",
      }
    }
  } = props || {};
  const { locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  const { data: originData, loading, errorMsg, changeDataItem } = data || {};
  const { selectedSegment, selectedGame } = changeDataItem || {};
  const { value: metricsValue } = selectedSegment || {};
  const [period, setPeriod] = useState(propsPeriod || "year");

  const { progressData, metrics, yearData, yearValue, yearPercentValue, progressList } = useMemo(() => {
    const progressData = originData?.breakdown_metrics?.[metricsValue] || {};
    const metrics = metricsMap[metricsValue] || {};
    const yearData = progressData?.year || {};
    const { value, kpi } = yearData || {};
    const yearValue = dataFormat({ value, formatRule: "bmk00" });
    const yearPercent = kpi ? (value / kpi) * 100 : 0;
    const yearPercentValue = kpi ? `${dataFormat({ value: yearPercent, formatRule: percentFormatRule })}%` : "-";
    const progressList = options.map((item: any) => {
      const data = progressData?.[item?.key] || {};
      const { value, kpi } = data || {};
      const percent = kpi ? (value / kpi) * 25 : 0;
      return {
        ...item,
        percent: percent > 25 ? 25 : percent,
      };
    });
    return { progressData, metrics, yearData, yearValue, yearPercentValue, progressList };
  }, [metricsMap, changeDataItem, options, originData?.breakdown_metrics, percentFormatRule]);
  // 筛选器和tab交互需要重置
  useEffect(() => {
    setPeriod("year");
    changeData?.("period", "year");
  }, [changeDataItem, selectedGame, tabFilter]);

  const onChange = (val: string) => {
    setPeriod(val);
    changeData?.("period", val);
  };

  const formatDate = (date: any) => (moment(date).isValid() ? moment(date).format('YYYY') : '');

  const filterDate = formatDate(tabFilter?.date);

  return <Abnormal
    component={<div className="dbh-progress-container">
      <CommonBubble className="dbh-renvenue-progress-tooltip" destroyOnClose={false} content={<RevenueProgressTooltip data={yearData} isEn={isEN} nameHeader={`${filterDate} ${getLanguage(isEN, 'Yearly', '年度')}`} />}>
        <div className={`dbh-progress-container-year ${period === "year" ? "active" : ""}`} onClick={() => onChange("year")}>
          <div className="dbh-progress-container-year-name">{filterDate} {getLanguage(isEN, metrics?.nameEn, metrics?.nameCn)}</div>
          <div className="dbh-progress-container-year-content">
            <div className="dbh-progress-container-year-percent">{yearPercentValue}</div>
            <div className="dbh-progress-container-year-value">{yearData?.value ? preUnit : ""}{yearValue}{yearData?.value ? endUnit : ""}</div>
          </div>
          <div className="dbh-progress-container-year-progress">
            {
              progressList?.map((item: any) => (
                <div
                  key={item?.key}
                  className="dbh-progress-container-year-progress-item"
                  style={{ width: `${item?.percent}%`, backgroundColor: item?.color, borderRight: item?.percent === 0 || item?.key === "quarter4" ? "none" : "1px solid #fff" }}
                />
              ))
            }
          </div>
        </div>
      </CommonBubble>
      <div className={`dbh-progress-container-group`}>
        <div>{getLanguage(isEN, "Quarter", "季度")}</div>
        <div>{getLanguage(isEN, "KPI%", "KPI占比")}</div>
      </div>
      {
        options?.map((item: any) => {
          const { key, text, color } = item || {};
          const data = progressData?.[key] || {};
          const { value, kpi } = data || {};
          const percent = kpi ? (value / kpi) * 100 : 0;
          const percentValue = kpi ? `${dataFormat({ value: percent, formatRule: percentFormatRule })}%` : "-";
          return (
            <CommonBubble className="dbh-renvenue-progress-tooltip" key={key} content={<RevenueProgressTooltip data={data} isEn={isEN} nameHeader={`${filterDate} ${text}`} />}>
              <div
                key={key}
                className={`dbh-progress-container-item ${period === key ? "active" : ""} ${percent === 0 ? "percent-zero" : ""}`}
                onClick={() => onChange(key)}
              >
                <div className="dbh-progress-container-item-name">{text}</div>
                <Progress width={300} percent={percent > 100 ? 100 : percent} theme="default" strokeColor={color} />
                <div className="dbh-progress-container-item-value">{percentValue}</div>
              </div>
            </CommonBubble>
          );
        })
      }
    </div>}
    isLoading={loading}
    isError={errorMsg}
    isNoData={false}
  />;
};
export default RevenueProgress;